(function () {
  var KEY = 'builtin_age_verified';

  function isVerified() {
    if (document.cookie.indexOf(KEY + '=1') !== -1) return true;
    try {
      return localStorage.getItem(KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function init() {
    var gate = document.getElementById('builtin-age-gate');
    if (!gate || isVerified()) return;

    var days = parseInt(gate.getAttribute('data-cookie-days'), 10) || 30;
    var denyUrl = gate.getAttribute('data-deny-url') || 'https://www.google.com';

    gate.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    var confirmBtn = gate.querySelector('[data-age-confirm]');
    var denyBtn = gate.querySelector('[data-age-deny]');

    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        var expires = new Date();
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = KEY + '=1;expires=' + expires.toUTCString() + ';path=/;SameSite=Lax';
        try { localStorage.setItem(KEY, '1'); } catch (e) {}
        gate.style.display = 'none';
        document.body.style.overflow = '';
      });
    }

    if (denyBtn) {
      denyBtn.addEventListener('click', function () {
        window.location.href = denyUrl;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
